import Level from 'app/src/game/Level';
import { useLevelContext } from 'app/src/game/LevelContext';
import * as React from 'react';
import { Redirect, useParams } from 'react-router-dom';

export default function LevelPage(): React.ReactElement | null {
	const { level = null } = useParams();

	const { setCurrentLevel, canPlayLevel } = useLevelContext();

	// When navigating to a level, tell the level controller that it's the new
	// current level.
	React.useEffect(() => {
		if (level) {
			setCurrentLevel(level);
		}

		return (): void => {
			setCurrentLevel(null);
		};
	}, [level, setCurrentLevel]);

	// If this level is invalid, redirect back to the homepage.
	if (level === null || !canPlayLevel(level)) {
		return <Redirect to="/" />;
	}

	return <Level level={level} key={level} />;
}
